/** 预计抽象到wphk-act-base中 */
import { TaskInfo, TaskJoinType, TaskStatus } from '@tencent/wphk-act-base-cgi';
import { computed } from 'vue-demi';

export enum TaskReceiveStatus {
  Received = 'received',
  notJoin = 'notJoin',
  notComplete = 'notComplete',
  notReceive = 'notReceive'
}

export const useTaskInfo = (taskInfo: TaskInfo) => {
  // 这里仅针对 累计次数的任务 requiredType===TaskRequiredType.count
  const isCompleted = computed(() => taskInfo.totalCnt >= taskInfo.requiredCount);
  const isReceived = computed(() => taskInfo.status === TaskStatus.gotPrize);
  const isJoined = computed(() => (
  // 主动领取类型 且 未领取任务
    taskInfo.taskJoinType === TaskJoinType.ManualJoin && taskInfo.status !== TaskStatus.notReceiveTask)
		// 自动领取类型
		|| taskInfo.taskJoinType === TaskJoinType.AutoJoin);
  const needCount = computed(() => taskInfo.requiredCount - taskInfo.totalCnt);
  const taskReceiveStatus = computed(() => {
    if (isReceived.value) {
      return TaskReceiveStatus.Received;
    } if (!isJoined.value) {
      return TaskReceiveStatus.notJoin;
    } if (!isCompleted.value) {
      return TaskReceiveStatus.notComplete;
    }
    return TaskReceiveStatus.notReceive;
  });
  return {
    taskReceiveStatus: taskReceiveStatus.value,
    needCount: needCount.value,
    requiredCount: taskInfo.requiredCount,
  };
};
